import { render } from "./NodeQCM.vue?vue&type=template&id=2844c850"
import script from "./NodeQCM.vue?vue&type=script&lang=js"
export * from "./NodeQCM.vue?vue&type=script&lang=js"
script.render = render

export default script